<template>
    <div class="huuli_erhzvi">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="huuli_erhzvi_top">
                        <div class="left">
                            <h3 v-if="$route.params.category_id == 1">Салбарын хууль, эрх зүйн актууд</h3>
                            <h3 v-else>Хууль эрх зүй</h3>
                        </div>
                        <div class="right">
                            <ul>
<!--                                <li>Нийт: {{total | number}}</li>-->
                                <li>
                                    <div class="select">
                                        <Input @on-search="calldata" v-model="searchWord"  search enter-button  placeholder="Хайх..."/>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="huuli_erhzvi_table">
                        <table width="100%">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th>НЭР</th>
                                <th>ОГНОО</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr :key="index" v-for="(law, index) in laws">
                                <td>{{index+1}}</td>
                                <td>{{law.name}}</td>
                                <td>{{law.ognoo | date}}</td>
                                <td>
                                  <a v-if="$route.params.category_id == 1" :href="law.file" target="_blank" class="button">Үзэх</a>
                                  <a v-else :href="law.link" target="_blank" class="button">Үзэх</a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <div class="total">Нийт: {{total | number}}</div>
                </div>
                <div class="col-10">
                    <div class="huuli_erhzvi_page">
                        <Page  @on-change="changePage"
                               :current-page="current_page"
                               :page-size="9"
                               :total="total"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getLaws } from "../api/index"

    export default {
        components: {},
        data () {
            return {
                laws: [],
                current_page:1,
                last_page:1,
                total: 0,
                searchWord: null,
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getLaws(this.$route.params.category_id, this.current_page, {searchWord:this.searchWord}).then(response=>{
                    this.laws = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    //console.log(this.laws);
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changePage(page) {
                this.current_page = page;
                this.calldata();
            },

        },
    }
</script>
